// auth/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api'; // Assuming api.js is in the '../services' directory

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/check-auth');
      if (response.status === 200 && response.data.user) {
        setIsAuthenticated(true);
        setUser(response.data.user);
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        console.error('User not authenticated');
        setIsAuthenticated(false);
        setUser(null);
      } else {
        console.error('Auth check error:', error);
        setIsAuthenticated(false);
        setUser(null);
      }
    } finally {
      setTimeout(() => setLoading(false), 100); // Small delay to prevent flash
    }
  };

  // Effect to log user state changes
  useEffect(() => {
    if (user) {
      console.log("User state updated:");
    }
  }, [user]);

  // Run once on mount
  useEffect(() => {
    checkAuth();
  }, []); // Empty dependency array - runs once  on mount

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      user,
      loading,
      checkAuth,
      setIsAuthenticated,
      setUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);